import React from 'react';
import DashBoard from "../DashBoard/index";
import Orders from "../Orders/index";
import Settlements from '../Settlements/index'
import BasicInfo from '../BasicInfo/index'
import Account from '../AccountInfo/index'
import Users from '../Users/index'
import Developer from '../Developer/index'
import {ROLES} from "../../reducers/types";
import {NavigationItem} from "../../components/SideBar/sidebar";
import CreateLink from "../CreateLink/index";
import SearchLink from "../SearchLink/index";
import ExchangeApply from "../ExchangeApply/index"
import ExchangeRecords from "../ExchangeRecords/index"

// sidebar路由
export const routes = [
    {
        path: "/app/dashboard",
        name: 'dashboard',
        exact: true,
        component: () => (<DashBoard/>)
    },
    {
        path: "/app/orders",
        name: 'orders',
        exact: true,
        component: () => (<Orders/>)
    },
    {
        path: "/app/settlements",
        name: 'settlements',
        exact: true,
        component: () => (<Settlements/>)
    },
    {
        path: "/app/basicInfo",
        name: 'basicInfo',
        component: () => (<BasicInfo/>)
    },
    {
        path: "/app/users",
        name: 'users',
        component: () => (<Users/>)
    },
    {
        path: "/app/account",
        name: 'account',
        component: () => (<Account/>)
    },
    {
        path: "/app/createLink",
        name: 'createLink',
        component: () => (<CreateLink/>)
    },
    {
        path: "/app/searchLink",
        name: 'searchLink',
        component: () => (<SearchLink/>)
    },
	{
	    path: "/app/exchangeApply",
	    name: 'exchangeApply',
	    component: () => (<ExchangeApply/>)
	},
	{
	    path: "/app/exchangeRecords",
	    name: 'exchangeRecords',
	    component: () => (<ExchangeRecords/>)
	},
    {
        path: "/app/developer",
        name: 'developer',
        component: () => (<Developer/>)
    }
];

// sidebar的link
export const sidebar:NavigationItem[] = [
    {id: 'dashboard', name: '收银台', link: '/app/dashboard'},
    {id: 'orders', name: '订单管理', link: '/app/orders'},
    {id: 'settlements', name: '结算管理', link: '/app/settlements'},
    {
        id: 'merchant',
        name: '商户管理',
        children: [
            {id: 'info', name: '基本信息', link: '/app/basicInfo'},
            {id: 'users', name: '员工信息', link: '/app/users'},
            {id: 'account', name: '账户信息', link: '/app/account'}
        ]
    },
	{
	    id: 'collection',
	    name: '收款管理',
	    children: [
	        {id: 'createLink', name: '生成链接', link: '/app/createLink'},
	        {id: 'searchLink', name: '查询链接', link: '/app/searchLink'},
	    ]
	},
	//{
	//    id: 'exchangeManage',
	//    name: '换汇管理',
	//    children: [
	//        {id: 'exchangeApply', name: '换汇申请', link: '/app/exchangeApply'},
	//        {id: 'exchangeRecords', name: '换汇记录', link: '/app/exchangeRecords'},
	//    ]
	//},
    {id: 'developer', name: '开发者', link: '/app/developer'}
]

type IEnumTpProp<R> = {[key in keyof typeof ROLES]: R };

export const rolesRight: IEnumTpProp<string[]> = {
    //ADMIN: ['dashboard', 'orders', 'merchant', 'info', 'users','account', 'collection', 'createLink', 'searchLink','exchangeManage','exchangeApply','exchangeRecords'],  // 门店管理员, 需要区分多门店和单门店
    //CASHIER: ['dashboard', 'orders', 'merchant', 'info', 'collection', 'createLink', 'searchLink'], // 收银员
    ADMIN: ['dashboard', 'orders', 'merchant', 'info', 'users','account', 'collection', 'createLink', 'searchLink'],  // 门店管理员, 需要区分多门店和单门店
    CASHIER: ['dashboard', 'orders', 'merchant', 'info', 'collection', 'createLink', 'searchLink'], // 收银员
    SUPER_ADMIN: ['*'], // 超级管理员，多门店
    NONE: []
}